{% block swag_migration_wizard_page_credentials_success %}
    <div class="swag-migration-wizard swag-migration-wizard-page-credentials-success">
        {% block swag_migration_wizard_page_success_error_alert %}
            <mt-banner v-if="errorMessageSnippet !== ''"
                      id="alert-error-message"
                      class="swag-migration-wizard-page-credentials-success__alert"
                      variant="attention">
                {{ $tc(errorMessageSnippet) }}
            </mt-banner>
        {% endblock %}

        {% block swag_migration_wizard_page_credentials_success_content %}
            <div class="swag-migration-wizard__content">
                {% block swag_migration_wizard_page_credentials_success_information %}
                    <div class="swag-migration-wizard__content-information">
                        {% block swag_migration_wizard_page_credentials_success_bubble %}
                            <div
                                v-if="errorMessageSnippet === ''"
                                class="swag-migration-wizard__bubble swag-migration-wizard__bubble--success"
                            >
                                <mt-icon
                                    class="swag-migration-wizard__success-icon"
                                    name="regular-check-circle"
                                    size="36px"
                                    decorative
                                />
                            </div>
                        {% endblock %}

                        {% block swag_migration_wizard_page_credentials_success_title %}
                            <h3 class="swag-migration-wizard__information-header">
                                {{ $tc('swag-migration.wizard.pages.credentials.success.contentTitle') }}
                            </h3>
                        {% endblock %}

                        {% block swag_migration_wizard_page_credentials_success_api_hint %}
                            {{ $tc('swag-migration.wizard.pages.credentials.success.contentInformation') }}
                        {% endblock %}
                    </div>
                {% endblock %}
            </div>
        {% endblock %}
    </div>
{% endblock %}
